import(/* webpackMode: "eager", webpackExports: ["PronunciationPage"] */ "/app/components/pronunciation/pronunciation-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
